 
export class LogbogAfsnit {
        public id: string;
        public titel: string;
        public beskrivelse: string;
        public createdDate: Date;
        public lastChangedDate: Date;
        public order: number;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/LogbogAfsnit.ts